<header class="w-full header-bg px-4 lg:px-6 py-4 text-white">

  <div class="flex items-center justify-between gap-4">

    <!-- LEFT -->
    <div class="flex items-center gap-4">

      <!-- MOBILE MENU -->
      <button
        type="button"
        class="lg:hidden p-2 rounded-xl bg-white shadow-md"
        (click)="toggleSidebar()"
      >

        <svg
          class="w-6 h-6 text-gray-800"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
        >

          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />

        </svg>

      </button>

      <!-- LOGO -->
      <div class="hidden lg:flex items-center gap-2 shrink-0">

        <img
          src="public/logos.png"
          [alt]="'LAYOUT.LOGO' | translate"
          class="h-14"
        />

      </div>

    </div>

    <!-- SEARCH -->
    <div class="hidden md:flex flex-1 max-w-xl">
<!-- 
      <div class="relative w-full">

        <span
          class="absolute inset-y-0 start-4 flex items-center text-white"
        >

          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
          >

            <circle cx="11" cy="11" r="8" />

            <line
              x1="21"
              y1="21"
              x2="16.65"
              y2="16.65"
            />

          </svg>

        </span>

        <input
          type="text"
          [attr.placeholder]="'HEADER.SEARCH_PLACEHOLDER' | translate"
          class="w-full rounded-2xl bg-[#0a1b73] py-4 ps-12 pe-4 text-sm text-white outline-none focus:ring-2 focus:ring-indigo-600"
        />

      </div> -->

    </div>

    <!-- RIGHT -->
    <div class="flex items-center gap-4 lg:gap-6">

      <!-- LANGUAGE -->
      <div class="relative">

        <button
          (click)="toggleLang()"
          class="flex items-center gap-2 text-sm cursor-pointer"
        >

          <!-- <img
            [src]="selectedLanguage.flag"
            class="h-7 lg:h-8"
          /> -->

          <span class="hidden lg:inline">
            {{ selectedLanguage.name }}
          </span>

          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
          >

            <polyline
              points="6 9 12 15 18 9"
            />

          </svg>

        </button>

        <!-- LANGUAGE DROPDOWN -->
        @if (isLangOpen) {

          <div
            class="absolute end-0 mt-2 w-44 bg-[#0f2457] rounded-2xl shadow-2xl overflow-hidden z-50 border border-white/10"
          >

            @for (lang of languages; track lang) {

              <button
                (click)="selectLanguage(lang)"
                class="w-full flex items-center gap-3 px-4 py-3 text-sm hover:bg-[#142f6b] transition-all"
              >

                <!-- <img
                  [src]="lang.flag"
                  class="h-5"
                /> -->

                <span>
                  {{ lang.name }}
                </span>

              </button>

            }

          </div>

        }

      </div>

      <!-- NOTIFICATION -->
      <div class="relative" #notificationWrapper>

        <!-- BUTTON -->
        <button
          (click)="toggleNotification()"

          class="relative p-2 rounded-xl bg-white hover:bg-[#142f6b] transition-all duration-200 shadow-sm"
        >

         <svg class="w-5 h-5 text-[#FFA412] " fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" >
              <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 01-3.46 0" />
            </svg>

          <!-- BADGE -->
          <span
            *ngIf="notifications.length > 0"
            class="absolute -top-1 -end-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center"
          >

            {{ notifications.length }}

          </span>

        </button>
        

        <!-- POPUP -->
        @if (isNotificationOpen) {

          <div
            class="fixed sm:absolute inset-0 sm:inset-auto sm:end-0 sm:mt-4 z-[99999] flex sm:block items-end sm:items-start justify-center sm:justify-end bg-black/40 sm:bg-transparent"
            (click)="closeNotification()"
          >

            <div
              class="w-full sm:w-[390px] h-[85vh] sm:h-auto bg-white rounded-t-[30px] sm:rounded-3xl shadow-2xl overflow-hidden border border-gray-100"
              (click)="$event.stopPropagation()"
            >

              <!-- HEADER -->
              <div
                class="px-5 py-4 bg-gradient-to-r from-[#0B0D5C] to-[#16298A] text-white"
              >

                <div
                  class="flex items-center justify-between"
                >

                  <div>

                    <h3
                      class="text-lg font-semibold"
                    >
                      {{ 'HEADER.NOTIFICATIONS' | translate }}
                    </h3>

                    <p
                      class="text-xs text-white/70 mt-1"
                    >
                      {{ notifications.length }}
                      {{ 'HEADER.UNREAD_NOTIFICATIONS' | translate }}
                    </p>

                  </div>

                  <!-- CLOSE -->
                  <button
                    class="sm:hidden h-9 w-9 rounded-full bg-white/10 flex items-center justify-center"
                    (click)="toggleNotification()"
                  >

                    ✕

                  </button>

                </div>

                <!-- MARK ALL -->
                <button
                  (click)="markAllAsRead()"
                  class="mt-4 text-xs bg-white/10 hover:bg-white/20 px-4 py-2 rounded-full transition-all"
                >

                  {{ 'HEADER.MARK_ALL_READ' | translate }}

                </button>

              </div>

              <!-- LIST -->
              <div
                class="max-h-[calc(85vh-120px)] sm:max-h-[420px] overflow-y-auto"
              >

                <!-- EMPTY -->
                <div
                  *ngIf="notifications.length === 0"
                  class="p-10 text-center"
                >

                  <div
                    class="h-16 w-16 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-4"
                  >

                    <svg
                      class="w-8 h-8 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                    >

                      <path
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5"
                      />

                    </svg>

                  </div>

                  <h3
                    class="text-sm font-semibold text-[#0B0D5C]"
                  >
                    {{ 'HEADER.NO_NOTIFICATIONS' | translate }}
                  </h3>

                  <p
                    class="text-xs text-gray-400 mt-1"
                  >
                    {{ 'HEADER.ALL_CAUGHT_UP' | translate }}
                  </p>

                </div>

                <!-- ITEMS -->
                @for (item of notifications; track item) {

                  <div
                    class="group px-4 sm:px-5 py-4 border-b border-gray-100 hover:bg-gray-50 transition-all cursor-pointer"
                    (click)="openNotification(item)"
                  >

                    <div
                      class="flex items-start gap-3"
                    >

                      <!-- ICON -->
                      <div
                        class="h-11 w-11 rounded-2xl bg-indigo-50 flex items-center justify-center shrink-0"
                      >

                        <svg
                          class="w-5 h-5 text-indigo-600"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                        >

                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M9 12h6m-6 4h6M7 4h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2z"
                          />

                        </svg>

                      </div>

                      <!-- CONTENT -->
                      <div
                        class="flex-1 min-w-0"
                      >

                        <div
                          class="flex items-start justify-between gap-2"
                        >

                          <h4
                            class="text-sm font-semibold text-[#0B0D5C] leading-5"
                          >

                            {{ item.title }}

                          </h4>

                          <span
                            class="text-[10px] text-gray-400 whitespace-nowrap"
                          >

                            {{ item.time }}

                          </span>

                        </div>

                        <p
                          class="text-xs sm:text-sm text-gray-500 mt-1 leading-5 line-clamp-2"
                        >

                          {{ item.message }}

                        </p>

                      </div>

                      <!-- UNREAD DOT -->
                      <div
                        *ngIf="!item.read"
                        class="w-2.5 h-2.5 rounded-full bg-indigo-600 mt-2"
                      >
                      </div>

                    </div>

                  </div>

                }

              </div>

              <!-- FOOTER -->
              <div
                class="px-5 py-4 bg-gray-50 border-t border-gray-100"
              >

                <button
                  routerLink="/notifications"
                  (click)="closeNotification()"
                  class="w-full h-11 rounded-2xl bg-[#0B0D5C] hover:bg-[#16298A] text-white text-sm font-medium transition-all"
                >

                  {{ 'HEADER.VIEW_ALL' | translate }}

                </button>

              </div>

            </div>

          </div>

        }

      </div>

<!-- USER -->
<div class="flex items-center gap-2 lg:gap-3">

  <div
    class="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm border-2 border-white/30 shrink-0"
    [style.background]="userAvatarColor"
  >
    {{ userInitial }}
  </div>

  <div class="hidden lg:block leading-tight">
    <p class="text-sm font-semibold">{{ userName }}</p>

  </div>

</div>

    </div>

  </div>

</header>